module.exports = __webpack_public_path__ + "img/ic_biangeng.6d431b18.png";